








import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { Link } from '@/common/interfaces/common';

@Component({
  name: 'link-list',
})
export default class LinkList extends Vue {
  @Prop()
  items!: Link[];
}
